module.exports = __webpack_public_path__ + "img/PL09175.66fcc544.png";